@if (enabled()) {
  <button
    type="button"
    class="fixed bottom-24 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full border border-primary bg-primary text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
    aria-label="Shopbox AI"
    (click)="open()"
  >
    <i class="pi pi-sparkles text-xl" aria-hidden="true"></i>
  </button>

  <p-drawer
    [visible]="panelOpen()"
    (visibleChange)="onVisibleChange($event)"
    position="right"
    appendTo="body"
    [modal]="true"
    [dismissible]="true"
    [closeOnEscape]="true"
    [closable]="false"
    [showCloseIcon]="false"
    [blockScroll]="true"
    [style]="drawerStyle"
    styleClass="sb-shopbox-ai-drawer"
  >
    <ng-template #headless>
      <div class="relative h-full min-h-0 w-full bg-sb-surface-primary">
        @if (frameUrl(); as url) {
          <iframe
            class="h-full w-full border-0"
            [src]="url"
            title="Shopbox AI"
            referrerpolicy="origin"
          ></iframe>
        } @else {
          <p class="p-4 text-sm text-sb-text-secondary">
            Shopbox AI is unavailable for this session.
          </p>
        }

        <button
          type="button"
          class="absolute right-3 top-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-sb-surface-primary text-sb-text-primary shadow-md hover:bg-sb-button-secondary-hover"
          aria-label="Close"
          (click)="close()"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </ng-template>
  </p-drawer>
}
